<template>
  <div class="header" @click="hide" v-loading="loadding"
    element-loading-text="打印单生成中"
    element-loading-spinner="el-icon-loading">
    <el-header id="header">
      <span class="hideAside">
        <!-- <div class="shape" @click="collapse">
          <img src="@/assets/image/icon_menu.png" />
        </div> -->
        <p>CRM订单</p>
      </span>
      <ul class="personal">
        <li>
          <div class="flex_align">
            <el-select v-model="checkVal" placeholder="请选择" size="mini" style="width:160px" @change="sendMessage">
              <el-option
                v-for="item in checkValOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="flex_align ml10" v-if="showLink">
              <div class="sucs " :class="linkType?'bg_67':'bg_E6'"></div>
              <div :class="linkType?'co_67':'co_e6'">{{linkType?'自动打印链接成功':'自动打印链接失败'}}</div>
            </div>
            <div class="flex_align ml10" v-if="!showLink">
              <el-button type="text" size="mini" @click="linkPrint">点击连接</el-button>
            </div>
            <!-- <el-button @click="pushdata">点击</el-button> -->
          </div>
        </li>
        <li>
          <span
            class="mendianTitle"
            v-if="this.$store.state.userInfo.mapInfo.storeName"
          >
            {{ this.$store.state.userInfo.mapInfo.storeName.name || "" }}/{{
              this.$store.state.userInfo.mapInfo.deptName
            }}
          </span>
          <span v-else class="mendianTitle">管理员</span>
        </li>
        <li class="fullScreen" @click="fullScreen">
          <el-tooltip
            class="item"
            effect="dark"
            content="全屏"
            placement="bottom"
          >
            <i class="fa fa-arrows-alt fa-lg"></i>
          </el-tooltip>
        </li>

        <!--  <li>{{ $t(`role.${this.$store.getters.info.role}`) }}</li> -->
        <li>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $t(`${this.$store.getters.info.permissions}`) }}
              <i
                class="el-icon-caret-bottom el-icon-arrow-down el-icon--right"
              ></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="dropdown-title">
              <!-- <el-dropdown-item command="a">
                {{ $t("userDropdownMenu.basicInfor") }}
              </el-dropdown-item> -->
              <!-- <el-dropdown-item command="changePwd">
                {{ $t("userDropdownMenu.changePassword") }}
              </el-dropdown-item> -->
              <el-dropdown-item command="logout" divided>
                {{ $t("userDropdownMenu.logout") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </ul>
    </el-header>
    <tabNav></tabNav>
    <el-dialog
      title="修改密码"
      :visible.sync="showChange"
      width="40%"
      center
      :modal-append-to-body="false"
    >
      <div class="flex_jus_cen flex_align">
        <div class="w100">旧密码：</div>
        <el-input
          placeholder="请输入旧密码"
          prefix-icon="el-icon-edit-outline"
          v-model="oldpwd"
          class="w280"
          type="password"
          autocomplete="new-password"
          maxlength="20"
          v-focus
        ></el-input>
      </div>
      <div class="mt20 flex_jus_cen flex_align">
        <div class="w100">新密码：</div>
        <el-input
          placeholder="请输入新密码"
          prefix-icon="el-icon-edit-outline"
          v-model="newpwd"
          class="w280"
          type="password"
          maxlength="20"
          minlength="6"
        ></el-input>
      </div>
      <div class="mt20 flex_jus_cen flex_align">
        <div class="w100">确认新密码：</div>
        <el-input
          placeholder="请确认新密码"
          prefix-icon="el-icon-edit-outline"
          v-model="newspwd"
          class="w280"
          type="password"
          maxlength="20"
          minlength="6"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChange = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitPwd" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <printCom ref="printCom" @successPrint="successPrint"></printCom>
  </div>
</template>

<script>
import printCom from "./../../printCom/index";
import Cookies from "js-cookie";
import langSelect from "../../../components/lang/langSelect";
import tabNav from "./tabNav";
import { getLodop } from "@/assets/js/LodopFuncs";
export default {
  name: "Header",
  components: { tabNav, langSelect,printCom},
  data() {
    return {
      goodslist:{},
      linkType:true,
      showLink:false,
      checkVal:'',
      checkValOptions:[
        {
          value: '10001',
          label: '顺丰面单'
        },
        {
          value: '10004',
          label: '中通面单'
        },
        {
          value: '10003',
          label: '拣货单'
        },
        // {
        //   value: '10005',
        //   label: '管易中通面单'
        // },
        {
          value: '10006',
          label: '管易拣货单'
        },
        // {
        //   value: '10002',
        //   label: '商品清单'
        // }
      ],
      oldpwd: "",
      newpwd: "",
      newspwd: "",
      showChange: false,
      isfullScreen: true,
      avatar: "./static/images/icon.jpg",
      websocket: null,
      loading:false,
      loadding:false,
      pData:{},
      heartBeatTimer:null,
    };
  },
  mounted() {
    this.initWebSocket();
    this.heartBeat();
  },
  methods: {
    heartBeat() {
      let _this = this;
      this.heartBeatTimer = setInterval(function () {
        if(!_this.websocket) {
          return;
        }

        _this.websocket.send("pong");
      }, 5000);
    },
    pushdata(){
      this.request('Get', this.adminApi.CRMORDER.push+'3',).then((res) => {
      });
    },
    //关闭
    websocketclose(e){
      this.showLink=false
      this.linkType=false
      this.$notify({
        title: '提示',
        message: '当前自动打印连接已断开，请检查！',
        duration: 0,
      });
    },
    // 启用 
    initWebSocket(){
      // let serviceName = 'wholesale'
      var linkType = localStorage.getItem('websocket-link-type');
      if(!linkType && !this.checkVal) {
        return;
      }

      if(linkType) {
        this.checkVal = linkType;
      }

      localStorage.setItem('websocket-link-type', this.checkVal);
      // //请求路径
      let socketUrl= process.env.WEBSOCKET_ROOT;
      this.websocket = new WebSocket(socketUrl);
      this.websocket.onopen = this.websocketonopen
      this.websocket.onerror = this.websocketonerror
      this.websocket.onmessage = this.websocketonmessage
      this.websocket.onclose = this.websocketclose;
    },
    websocketonopen() {
      this.linkType=true
      this.showLink=true
      this.sendMessage()
    },
    successPrint(val, orderNo){
      if (!this.websocket){
        return false
      }
      let data = {
        code :this.checkVal,
        data :orderNo,
        status:val,
      }
      console.log(JSON.stringify(data));
      this.websocket.send(JSON.stringify(data));
    },
    sendMessage() {
      if (!this.websocket){
        return false
      }
      let token = this.$store.state.token
      let data = {
        code:'10000',
        data :{
          type:this.checkVal,
          token:token
        }
      }

      localStorage.setItem('websocket-link-type', this.checkVal);
      this.websocket.send(JSON.stringify(data));
    },
    websocketonerror(e) { //错误
      let that = this
      that.$notify({
        title: '提示',
        message: '已断开连接,请刷新网页重新连接',
        duration: 0,
      });
      that.websocket = null;
    },
    websocketonmessage(e){ //数据接收
      let that = this
      if("ping" == e.data) {
        return;
      }
      let redata = JSON.parse(e.data)
      console.log(redata)
      this.pData = redata
      if (this.checkVal=='10003'){
        // 拣货单
        this.$refs.printCom.pritingPick(redata.data)
      } else if (this.checkVal=='10001'){
        // 物流面单
        this.$refs.printCom.printWaybill(redata.data)
      } else if (this.checkVal=='10002'){
        // 商品清单
        this.$refs.printCom.Pinventory(redata.data)
      } else if (this.checkVal=='10004'){
        // 中通面单
        this.$refs.printCom.printZt(redata.data)
      } else if (this.checkVal=='10005'){
        // 打印管易中通面单
        this.$refs.printCom.printZts(redata.data)
      } else if (this.checkVal=='10006'){
        // 打印管易检货单
        this.$refs.printCom.pritingPick(redata.data)
      }
    },
    collapse() {
      this.$store.dispatch("collapse");
    },
    //全屏
    fullScreen() {
      if (this.isfullScreen) {
        var docElm = document.documentElement;
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
        this.isfullScreen = false;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.isfullScreen = true;
      }
    },
    //退出当前登录
    handleCommand(command) {
      Cookies.remove("token");
      window.localStorage.clear();
      location.reload();
      // if (command === "logout") {
      //   Cookies.remove("token");
      //   window.localStorage.clear();
      //   location.reload();
      //   return;
      //   this.request(
      //     this.Appconstance.REQUEST_TYPE.GET,
      //     this.adminApi.upload.loginOut,
      //     {}
      //   ).then((res) => {
      //     Cookies.remove("token");
      //     window.localStorage.clear();
      //     location.reload();
      //   });
      // } else if (command === "changePwd") {
      //   this.showChange = true;
      // }
    },
    //修改密码
    submitPwd() {
      if (this.oldpwd == "") {
        this.MGridUtil.MessageShow("请填写旧密码", "warning");
        return false;
      }
      if (this.newpwd == "") {
        this.MGridUtil.MessageShow("请填写新密码", "warning");
        return false;
      }
      if (this.newpwd.length < 6) {
        this.MGridUtil.MessageShow("新密码不能少于6位", "warning");
        return false;
      }
      if (this.newspwd == "") {
        this.MGridUtil.MessageShow("请确认新密码", "warning");
        return false;
      }
      if (this.newpwd != this.newspwd) {
        this.MGridUtil.MessageShow("两次密码不一致请重新填写", "warning");
        return false;
      }
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.upload.changePassword + this.oldpwd + "/" + this.newpwd,
        {},
        true,
        true
      ).then((res) => {
        if (res.status == 200) {
          this.handleCommand("logout");
        }
      });
    },
    // 隐藏菜单栏
    hide() {
      this.$eventHub.$emit("toshow", { bool: false });
    },
    
    linkPrint(){
      if (!this.checkVal){
        return this.MGridUtil.MessageShow("请选择打印单据", "warning")
      }
      this.initWebSocket()
    },
    
  },
  watch: {
    showChange(val) {
      if (!val) {
        this.oldpwd = "";
        this.newpwd = "";
        this.newspwd = "";
      }
    },
    newpwd(val) {
      if (val.length >= 20) {
        this.MGridUtil.MessageShow("密码长度不能超过20位", "warning");
      }
    },
  },
};
</script>

<style lang="scss">
$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: ($left, $right);
%w100 {
  width: 100%;
}

%h100 {
  height: 100%;
}

%cursor {
  cursor: pointer;
}

.header {
  // position: fixed;
  // top: 0;
  // z-index: 1999;
  // width: 100%;
  height: 1rem;
  flex: 0 0 auto;
}

html,
body,
#app,
.el-container,
#asideNav,
ul.el-menu {
  @extend %h100;
}

@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}

#header {
  max-height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  height: 60px;
  background: #f7fbff;
  box-shadow: 0px 2px 8px 0px #d0d6dc;
  position: relative;
  .hideAside {
    @extend %cursor;
  }
  .personal {
    display: flex;
    position: absolute;
    right: 5%;
    z-index: 1;
    flex-direction: row;
    color: #61a7cf;
    font-weight: bold;
    li {
      @include set-value(margin, 13px);
      font-size: 12px;
      .mendianTitle {
        font-weight: bold;
        color: #61a7cf;
        font-size: 14px;
      }
    }
    .fullScreen {
      @extend %cursor;
    }
    .el-dropdown-link {
      @extend %cursor;
    }
    .icon img {
      margin-#{$top}: 7px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      width: 40px;
      height: 40px;
    }
  }
}
.hideAside {
  display: flex;
  align-items: center;
  
}
.hideAside p {
  font-weight: bold;
  color: #61a7cf;
  font-size: 24px;
  padding-left: 24px;
  white-space: nowrap;
}
.el-dropdown {
  color: #61a7cf !important;
  font-weight: bold;
}
.w280 {
  width: 280px;
}
.w100 {
  width: 100px;
  text-align: center;
}
.mt20 {
  margin-top: 20px;
}
.sucs{
  width: 15px;
  height: 15px;
  border-radius: 50%;
}
.bg_67{
  background: #67C23A;
}
.bg_E6{
  background: #E6A23C;
}
.co_67{
  color:#67C23A;
}
.co_e6{
  color: #E6A23C;
}
.flex_align{
  display: flex;
}
.ml10{
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/header/header.vue